import { render, staticRenderFns } from "./course-start-indicator.vue?vue&type=template&id=40d50d6a"
import script from "./course-start-indicator.vue?vue&type=script&lang=js"
export * from "./course-start-indicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports